var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({class:[{
  'jds-button': true,
  'font-sans-1': true,
}, _vm.classVariant]},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }